import { showMsg } from '@/utils/snackbar'

export default {
    mounted(el) {

        let timeout = null

        el.addEventListener('input', (e) => {

            const value = e.target.value

            const newValue =
                value.replace(/\D/g, '')

            // اگر کاراکتر غیرمجاز وارد شده بود
            if (newValue !== value) {

                // جلوگیری از اسپم شدن snackbar
                if (!timeout) {

                    showMsg(
                        'فقط عدد مجاز است',
                        'red'
                    )

                    timeout = setTimeout(() => {
                        timeout = null
                    }, 1500)
                }

                e.target.value = newValue

                e.target.dispatchEvent(
                    new Event('input', { bubbles: true })
                )
            }

        })
    }
}
